import { Notes } from "../../types";
import { object, number } from "yup";

export const schema = object({
  security_note: number()
    .required("La note de sécurité est requise")
    .min(1, "La note de sécurité doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  comfort_note: number()
    .required("La note de confort est requise")
    .min(1, "La note de confort doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  capacity_note: number()
    .required("La note de capacité est requise")
    .min(1, "La note de capacité doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  quality_note: number()
    .required("La note de qualité est requise")
    .min(1, "La note de qualité doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  consumption_note: number()
    .required("La note de consommation est requise")
    .min(1, "La note de consommation doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  maintenance_cost_note: number()
    .required("Le coût de maintenance est requise")
    .min(1, "Le coût de maintenance doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  fun_note: number()
    .required("La note de fun est requise")
    .min(1, "La note de fun doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  equipment_note: number()
    .required("La note d'équipement est requise")
    .min(1, "La note d'équipement doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  reliability_note: number()
    .required("La note de fiabilité est requise")
    .min(1, "La note de fiabilité doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
  design_note: number()
    .required("La note de design est requise")
    .min(1, "La note de design doit être entre 1 et 10")
    .max(10, "La note doit être entre 1 et 10"),
});

export const REVIEW_NOTE_NAMES: (keyof Notes)[] = [
  "security_note",
  "comfort_note",
  "capacity_note",
  "quality_note",
  "consumption_note",
  "maintenance_cost_note",
  "fun_note",
  "equipment_note",
  "reliability_note",
  "design_note",
];
